import { Injectable } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { StorageProvider } from '../../providers/storage/storage';
import { KpisTechnicienComponent } from './kpis-technicien.modal';
import { KpiFilter, Kpis } from './kpi-model';
import { KpisTechnicienProvider } from './kpis-technicien.provider';
import { UserService } from '../../providers/auth/user.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class KpisTechnicienModalService {
  constructor(
    private storageProvider: StorageProvider,
    private userService: UserService,
    private modalController: ModalController,
    private kpiTechnicienProvider: KpisTechnicienProvider
  ) {}

  async displayKpis() {
    const previousWeekKpiFilter = this.previousWeekKpiFilter();
    if (!(await this.areKpisAcknowledged(previousWeekKpiFilter))) {
      let previousWeekKpis = await this.kpiTechnicienProvider.getKpis(this.userService.getId(), previousWeekKpiFilter);

      if (previousWeekKpis) {
        const modal = await this.modalController.create({
          component: KpisTechnicienComponent,
          componentProps: { kpis: previousWeekKpis },
        });
        modal.onDidDismiss().then((result) => {
          this.acknowledgeKpis(previousWeekKpiFilter);
        });
        await modal.present();
      }
    }
  }

  async getKpis() {
    const previousWeekKpiFilter = this.previousWeekKpiFilter();
    return await this.kpiTechnicienProvider.getKpisWithErrors(this.userService.getId(), previousWeekKpiFilter);
  }

  private async areKpisAcknowledged(kpiFilter: KpiFilter): Promise<boolean> {
    const actualKpiFilterInStorage: KpiFilter | null = (await this.storageProvider.get(
      this.computeKpisStorageKey()
    )) as KpiFilter;
    return kpiFilter.compareTo(actualKpiFilterInStorage);
  }

  async acknowledgeKpis(kpiFilter: KpiFilter) {
    await this.storageProvider.set(this.computeKpisStorageKey(), kpiFilter);
  }

  previousWeekKpiFilter(): KpiFilter {
    const computeDate = moment().add(-7, 'd');
    let previousWeek = computeDate.isoWeek();
    let year = computeDate.year();
    return new KpiFilter(year, previousWeek);
  }

  computeKpisStorageKey(): string {
    return this.userService.getDkCodeRessource() + '_kpis';
  }
}
